import { IconWrapper } from '../runtime';
export default IconWrapper('eye', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none",
      "stroke-width": props.strokeWidth
    }
  }, [h("g", {
    "attrs": {
      "id": "group-0",
      "stroke": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#333333',
      "fill": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#333333'
    }
  }, [h("circle", {
    "attrs": {
      "cx": "8",
      "cy": "8",
      "r": "2.25",
      "fill": "none",
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 3.25C2.85149 3.25 1 8 1 8C1 8 2.85149 12.75 8 12.75C13.1485 12.75 15 8 15 8C15 8 13.1485 3.25 8 3.25Z",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "fill": "none",
      "vector-effect": "non-scaling-stroke"
    }
  })])]);
});